/* Top Racing Point - passo (filettatura) per le auto senza passo in trp-dist-auto.js (24/10/2026).
   Regole per marca/modello; i modelli dubbi restano senza passo (la ricerca dice di controllare il libretto o scriverci). */
(function(){
  var A=window.TRP_DIST_AUTO; if(!A) return;
  var U='1/2 UNF';
  function regola(marca,m){
    function R(p){ return new RegExp(p,'i').test(m); }
    switch(marca){
      case 'Alfa Romeo': return 'M12x1.25';
      case 'Aston Martin': return 'M12x1.5';
      case 'Audi': case 'Bentley': case 'Lamborghini': case 'Porsche': case 'Tesla': return 'M14x1.5';
      case 'BMW': return R('E21|E30|E39|Z3|Z4') ? 'M12x1.5' : 'M14x1.25';
      case 'Buick': case 'Pontiac': case 'Chrysler': return 'M12x1.5';
      case 'Cadillac': return R('Cimarron') ? 'M12x1.5' : 'M14x1.5';
      case 'Chevrolet': if(R('Beretta|Cavalier|Corsica')) return 'M12x1.5'; return R('Avalanche|Silverado|Tahoe') ? 'M14x1.5' : '';
      case 'GMC': return R('Sierra') ? 'M14x1.5' : '';
      case 'Citroen': case 'Dacia': case 'Daihatsu': case 'Fiat': case 'Lotus': case 'Mazda': case 'MG': case 'Mini': case 'Mitsubishi': case 'Opel': case 'Peugeot': case 'Proton': case 'Rover': case 'Volvo': case 'Land Rover': return 'M12x1.5';
      case 'Dodge': if(R('Nitro')) return U; return R('Durango|Ram') ? 'M14x1.5' : 'M12x1.5';
      case 'Ford': if(R('F150')) return 'M14x2.0'; if(R('Aerostar')) return U; return R('Galaxy') ? 'M14x1.5' : 'M12x1.5';
      case 'Lincoln': return 'M14x2.0';
      case 'Honda': return R('Odyssey') ? 'M14x1.5' : 'M12x1.5';
      case 'Hyundai': if(R('Ioniq5|Ioniq6')) return 'M14x1.5'; return R('Nexo|Stargazer') ? '' : 'M12x1.5';
      case 'Kia': return R('EV6|EV9') ? 'M14x1.5' : 'M12x1.5';
      case 'Infiniti': case 'Saab': return 'M12x1.25';
      case 'Subaru': return R('Justy') ? 'M12x1.5' : 'M12x1.25';
      case 'Jeep': if(R('Compass|Patriot')) return 'M12x1.5'; return R('WK2|WL|JL|Gladiator') ? 'M14x1.5' : U;
      case 'Lexus': return R('NX \\(2021|RX \\(2022|RZ') ? '' : 'M12x1.5';
      case 'Nissan': return R('Ariya|Townstar') ? '' : 'M12x1.25';
      case 'Renault': return R('Koleos') ? '' : 'M12x1.5';
      case 'Seat': case 'Skoda': case 'Volkswagen':
        if(R('Touareg')) return 'M14x1.5';
        return /\bMii\b|Citigo|\bUp\b|XL1/.test(m) ? '' : 'M12x1.5';
      case 'Suzuki': if(R('Across|Swace|Invicto')) return 'M12x1.5'; return R('Escudo|Grand Nomade|Grand Vitara|Kizashi|S-Cross|Swift|SX4|^Vitara \\(') ? 'M12x1.25' : '';
      case 'Toyota': if(R('GT 86|GR 86')) return 'M12x1.25'; if(R('Landcruiser \\(2009')) return 'M14x1.5'; return R('BZ4X') ? '' : 'M12x1.5';
    }
    return '';
  }
  for(var marca in A){
    A[marca].forEach(function(x){
      if(x[1].some(function(f){ return f[2]; })) return;
      var th=regola(marca,x[0]); if(!th) return;
      x[1]=x[1].map(function(f){ var c=f.slice(); c[2]=th; return c; });
    });
  }
})();
